import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/notFoundIcon.svg'
import _imports_1 from '@/assets/images/notFoundIconMobile.svg'


const _withScopeId = n => (_pushScopeId("data-v-c7fef8ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto pb-4 px-4" }
const _hoisted_2 = { class: "text-4xl md:text-5xl xl:py-20 py-10" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "flex flex-col md:bg-gray-200 pt-10 pb-20 items-center" }
const _hoisted_5 = ["alt"]
const _hoisted_6 = ["alt"]

import ButtonPrimary from '@/components/atoms/ButtonPrimary.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Page_404',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t('notFoundPage.error404')), 1),
        _hoisted_3,
        _createTextVNode(_toDisplayString(_ctx.$t('notFoundPage.pageNotExist')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: _ctx.$t('notFoundPage.pageNotFoundIconAlt'),
        class: "pb-9 notFound-image hidden md:block"
      }, null, 8, _hoisted_5),
      _createElementVNode("img", {
        src: _imports_1,
        alt: _ctx.$t('notFoundPage.pageNotFoundIconAlt'),
        class: "pb-9 notFound-image md:hidden"
      }, null, 8, _hoisted_6),
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createVNode(ButtonPrimary, {
            name: _ctx.$t('notFoundPage.backToHomePage')
          }, null, 8, ["name"])
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})